import { getController, apiService as Service } from '@/services/service'

const url = 'units'

export const unitService = {
	...getController<Api.Unit, Api.UnitPostInput, Api.UnitUpdateInput>(url),
	tenantsGet: (id: number) =>
		Service.get({
			url: `${url}/${id}/persons?q[]=role.em&v[]=M&rel=["address"]&sm=1&scope=all`,
		}),
	ownerGet: (id: number) => Service.get({ url: `${url}/${id}/owner` }),
}

export default unitService
